import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allPosition }) => {
  if (!allPosition) return state;
  return state.merge({ allPosition });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllLinePositions = (state, { linePositions }) => {
  if (!linePositions) return false;
  return state.merge({ linePositions });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_BY_LINE_ID,
    actionFunction: setAllLinePositions,
  },
];
